import FlightstatusSearchboxAirline from '../../components/FlightStatus/FlightStatusSearchboxAirline.vue'
import FSFormater from '../../mixins/FSFormater'

Vue.component('page-flightstatus-airline', {

    components: { FlightstatusSearchboxAirline },

    mixins: [ FSFormater ],

    data() {
        return {
            results: { arriving: {}, departing: {} },
            type: apr.type,
            isLoading: false,
	        searchboxEdit: true,
	        information: apr.content,
	        hasSearched: false,
        }
    },
	
	watch: {
		'isLoading': function () {
			this.hasSearched = true;
		},
		'searchboxEdit': function () {}
	},

    mounted() {},
    
    beforeUpdate() {
        $(this.$refs.amazon).addClass('d-flex')
        $(this.$refs.amazon).addClass('justify-content-center')
    }
});
